'use client'

import { ComponentType } from 'react'
import Button from '../ui-other/basic/Button'

type AdminButtonProps = {
  title: string
  hint?: string
  callback: () => void
}

export const AdminButton: ComponentType<AdminButtonProps> = ({
  title,
  hint,
  callback
}) => {
  return (
    <Button small onClick={callback} tooltip={hint}>
      {title}
    </Button>
  )
}
